import React from 'react';
// Stub: 원본 ExcelViewer 누락 → 기능 비활성. 추후 복구 필요.
export default function ExcelViewer(props) {
  return (
    <div className="p-4 text-sm text-gray-500 border border-gray-200 rounded">
      Excel 뷰어 (stub) — 컴포넌트 누락 상태입니다.
    </div>
  );
}
